import { Model } from 'app/model/backendmodel';
import { Owned } from 'app/model/base/named';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { IModel } from 'app/model/base/annotation';
import { FormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/format-read-settings';
import { BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';

export const formatReadSettingsAdapts = {
    type: '*',
    compressionProperties: '*'
};

export abstract class FormatReadSettingsAdapter<T, U> extends BaseAsyncAdapter<T, U> {
    public static getCommonReadSettingsProperties(settingType: string): Model.FormatReadSettings {
        return {
            type: settingType
        };
    }

    public static createReadSettingsWithCommonProperties(model: IModel, copySource: CopySource): FormatReadSettings {
        return Owned.create<FormatReadSettings>(model, copySource);
    }

    protected async _toAzureResource(tridentResource: ITridentResource): Promise<U> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
